import { Action, ActionReducer, INIT } from '@ngrx/store';
import { hydrateSuccess, resetStore } from '../actions/hydration.actions';
import { PaceOfflineFeatureState } from '../state';

const isHydrateSuccess = (action: Action): action is ReturnType<typeof hydrateSuccess> => {
    return action.type === hydrateSuccess.type;
};

const isResetRequired = (action: Action): action is ReturnType<typeof resetStore> => {
    return action.type === resetStore.type;
};

export const hydrationMetaReducer = (
    reducer: ActionReducer<PaceOfflineFeatureState>,
): ActionReducer<PaceOfflineFeatureState> => {
    return (state, action) => {
        if (isResetRequired(action)) {
            return reducer(undefined, { type: INIT });
        } else if (isHydrateSuccess(action)) {
            return reducer(action.state, action);
        } else {
            return reducer(state, action);
        }
    };
};
